module.exports = __webpack_public_path__ + "fonts/CircularStd-Black.7d5cbf57.woff2";